export default "__VITE_ASSET__Dgt3ywqT__"